import "./styles/main.css";
import "fslightbox";
import MatchHeight from "@tannerhodges/match-height";
import "./scripts/theme/global";
import "./scripts/theme/blog";
import "./scripts/theme/waves";
import "./scripts/theme/blocks/SimpleContent";
import "./scripts/theme/blocks/Survey";
import "./scripts/theme/controllers/CTAPopUp";
import "./scripts/theme/controllers/ShowPrice";
import "./scripts/theme/controllers/TocToggle";

import Accordions from "./scripts/theme/controllers/Accordions";
new Accordions();

import Autocomplete from "./scripts/theme/controllers/Autocomplete";
new Autocomplete();

import AutoExpandTextarea from "./scripts/theme/controllers/AutoExpandTextarea";
new AutoExpandTextarea("textarea");

import BackgroundAnimator from "./scripts/theme/controllers/BackgroundAnimator"; './scripts/theme/controllers/BackgroundAnimator';
new BackgroundAnimator();

import BusinessHours from "./scripts/theme/controllers/BusinessHours";
new BusinessHours();

import Chat from "./scripts/theme/controllers/Chat";
new Chat();

import EHTPopUp from "./scripts/theme/controllers/EHTPopUp";
new EHTPopUp();

import Events from "./scripts/theme/controllers/Events";
if (document.body.classList.contains("single-event") || document.body.classList.contains("post-type-archive-event")) {
    new Events();
}

import InfinityLoader from "./scripts/theme/controllers/InfinitLoader";
new InfinityLoader();

import MobileNavigation from "./scripts/theme/controllers/MobileNavigation";
new MobileNavigation();

import Parallax from "./scripts/theme/controllers/Parallax";
new Parallax();

import Products from "./scripts/theme/controllers/Products";
new Products();

import Search from "./scripts/theme/controllers/Search";
new Search();

import Sliders from "./scripts/theme/controllers/Sliders";
new Sliders();

import TabbedWoocommerceSliders from "./scripts/theme/blocks/TabbedWooCommerceSliders";
new TabbedWoocommerceSliders();

window.addEventListener('DOMContentLoaded', (event) => {
    MatchHeight.update();
});